(function () {
    'use strict';

    angular.module('PWAPoCApp')
        .factory('toasterService', [
            '$rootScope',
            '$timeout',
            function ($rootScope, $timeout) {

                const MAX_TOASTS = 5;

                $rootScope.toasts = [];

                function show(message, options = {}) {
                    const toast = {
                        message,
                        type: options.type || 'success',
                        persist: options.persist || false
                    };

                    if ($rootScope.toasts.length >= MAX_TOASTS) {
                        $rootScope.toasts.shift();
                    }

                    $rootScope.toasts.push(toast);

                    if (!toast.persist) {
                        const duration = options.duration || 3000;

                        $timeout(function () {
                            const index = $rootScope.toasts.indexOf(toast);
                            if (index >= 0) {
                                $rootScope.toasts.splice(index, 1);
                            }
                        }, duration);
                    }
                }

                return {
                    success: function (msg, opts = {}) {
                        show(msg, { ...opts, type: 'success' });
                    },
                    error: function (msg, opts = {}) {
                        show(msg, { ...opts, type: 'error' });
                    },
                    info: function (msg, opts = {}) {
                        show(msg, { ...opts, type: 'info' });
                    }
                };
            }
        ]);
})();
